import React from 'react';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HeaderContador from './HeaderContador';
import Roles from '../../config/roles';
// Import directo del servicio, no del barrel: el barrel arrastra las páginas del feature
import InventariosService from '../../features/inventarios/api/inventarios.api';

// Referencia estable a nivel de módulo para no reiniciar el intervalo en cada render
const cargarInventariosSinRevisar = () => InventariosService.contarSinRevisar();

/**
 * Icono del header con el número de inventarios sin revisar (pendientes, en curso o
 * completados); solo admin, navega a /inventarios
 */
export default function HeaderInventarios({ compacto = false }) {
    return (
        <HeaderContador
            icon={FactCheckIcon}
            ruta="/inventarios"
            titulo="inventarios sin revisar"
            roles={[Roles.ADMIN.role]}
            cargarContador={cargarInventariosSinRevisar}
            color="success"
            compacto={compacto}
            triggerKey="inventarios"
        />
    );
}
